export { default as SignUpConfirmation } from './sign-up-confirmation';
